(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 749;
  const swiperInstances = new Map();

  function updateNoHoverSwapAll() {
    document.querySelectorAll('[data-ctab-section]').forEach(function (section) {
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        section.classList.add('ctab--no-hover-swap');
      } else {
        section.classList.remove('ctab--no-hover-swap');
      }
    });
  }

  function initCtabSwiper(swiperElement, sectionId, tabLabel) {
    if (!swiperElement) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        initCtabSwiper(swiperElement, sectionId, tabLabel);
      }, 100);
      return;
    }

    const instanceKey = sectionId + '-' + tabLabel;
    if (swiperInstances.has(instanceKey)) {
      const existingSwiper = swiperInstances.get(instanceKey);
      if (existingSwiper && existingSwiper.destroy) {
        existingSwiper.destroy(true, true);
      }
    }
    swiperElement._ctabSwiper = null;

    const panel = swiperElement.closest('.ctab__panel');
    const paginationEl = panel ? panel.querySelector('.swiper-pagination') : null;
    const progressBar = panel ? panel.querySelector('[data-progress-bar]') : null;
    const progressBarFill = progressBar ? progressBar.querySelector('.ctab__progress-bar') : null;

    var accumulatedWheelDelta = 0;
    var wheelRafId = null;

    function updateProgressBar(swiper, progressOverride) {
      if (!progressBarFill || !swiper) return;
      const thumbWidthPercent = 20;
      const maxLeft = 100 - thumbWidthPercent;
      let progress =
        progressOverride !== undefined
          ? Math.min(1, Math.max(0, progressOverride))
          : Math.min(1, Math.max(0, swiper.progress));
      if (Number.isNaN(progress) || !Number.isFinite(progress)) progress = 0;
      const leftPct = progress * maxLeft;
      progressBarFill.style.left = leftPct + '%';
    }

    function applyProgressToSwiper(swiper, progress) {
      if (!swiper || swiper.slides.length <= 1) return;
      var swiperMin = swiper.minTranslate();
      var swiperMax = swiper.maxTranslate();
      var minT = Math.min(swiperMin, swiperMax);
      var maxT = Math.max(swiperMin, swiperMax);
      var currentT = typeof swiper.getTranslate === 'function' ? swiper.getTranslate() : swiper.translate;
      var newT = maxT + progress * (minT - maxT);
      if (typeof swiper.setTransition === 'function') swiper.setTransition(0);
      swiper.setTranslate(newT);
      updateProgressBar(swiper, progress);
    }

    function setupProgressBarDrag(progressBarEl, swiper) {
      if (!progressBarEl || !swiper) return;
      if (progressBarEl._ctabProgressDragSetup) {
        progressBarEl._ctabProgressSwiper = swiper;
        return;
      }
      progressBarEl._ctabProgressDragSetup = true;
      progressBarEl._ctabProgressSwiper = swiper;

      function getProgress(clientX) {
        var rect = progressBarEl.getBoundingClientRect();
        var p = (clientX - rect.left) / rect.width;
        return Math.min(1, Math.max(0, p));
      }

      var activePointerId = null;
      var dragRafId = null;
      var lastDragClientX = null;

      function applyDragFrame() {
        dragRafId = null;
        var x = lastDragClientX;
        if (x == null) return;
        var s = progressBarEl._ctabProgressSwiper;
        if (!s) return;
        var progress = getProgress(x);
        applyProgressToSwiper(s, progress);
      }

      function onPointerMove(e) {
        if (e.pointerType === 'touch') e.preventDefault();
        lastDragClientX = e.clientX;
        if (dragRafId != null) return;
        dragRafId = requestAnimationFrame(applyDragFrame);
      }

      function endDrag(e) {
        if (activePointerId !== null && e.pointerId !== activePointerId) return;
        activePointerId = null;
        lastDragClientX = null;
        if (dragRafId != null) {
          cancelAnimationFrame(dragRafId);
          dragRafId = null;
        }
        progressBarEl.classList.remove('is-dragging');
        try {
          progressBarEl.releasePointerCapture(e.pointerId);
        } catch (err) {}
        progressBarEl.removeEventListener('pointermove', onPointerMove);
        progressBarEl.removeEventListener('pointerup', endDrag);
        progressBarEl.removeEventListener('pointercancel', endDrag);
        progressBarEl.removeEventListener('pointerleave', onPointerLeave);
        var s = progressBarEl._ctabProgressSwiper;
        if (s && s.slides.length > 1) {
          if (typeof s.setTransition === 'function') s.setTransition(300);
          var progress = Math.min(1, Math.max(0, s.progress));
          if (Number.isNaN(progress) || !Number.isFinite(progress)) progress = 0;
          updateProgressBar(s, progress);
        }
      }

      function onPointerLeave(e) {
        if (activePointerId !== null && e.pointerId === activePointerId) endDrag(e);
      }

      progressBarEl.addEventListener(
        'pointerdown',
        function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.cancelable) e.preventDefault();
          activePointerId = e.pointerId;
          progressBarEl.classList.add('is-dragging');
          var progress = getProgress(e.clientX);
          applyProgressToSwiper(progressBarEl._ctabProgressSwiper, progress);
          progressBarEl.setPointerCapture(e.pointerId);
          progressBarEl.addEventListener('pointermove', onPointerMove, { passive: false });
          progressBarEl.addEventListener('pointerup', endDrag);
          progressBarEl.addEventListener('pointercancel', endDrag);
          progressBarEl.addEventListener('pointerleave', onPointerLeave);
        },
        { passive: false },
      );
    }

    var swiper = new Swiper(swiperElement, {
      initialSlide: 0,
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      grabCursor: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      on: {
        init: function () {
          var s = this;
          updateProgressBar(s);
          if (progressBar) setupProgressBarDrag(progressBar, s);
          if (swiperElement._ctabWheelAdded) return;
          swiperElement._ctabWheelAdded = true;
          swiperElement.addEventListener(
            'wheel',
            function (e) {
              var s = swiperElement._ctabSwiper;
              if (!s || typeof s.minTranslate !== 'function') return;
              var isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
              if (!isHorizontal) return;
              var rawDelta = -e.deltaX;
              var sensitivity = 11;
              accumulatedWheelDelta += rawDelta * sensitivity;
              if (Math.abs(accumulatedWheelDelta) < 0.5) return;
              e.preventDefault();
              if (wheelRafId == null) {
                wheelRafId = requestAnimationFrame(function applyWheelFrame() {
                  wheelRafId = null;
                  s = swiperElement._ctabSwiper;
                  if (!s || Math.abs(accumulatedWheelDelta) < 0.5) return;
                  var swiperMin = s.minTranslate();
                  var swiperMax = s.maxTranslate();
                  var minT = Math.min(swiperMin, swiperMax);
                  var maxT = Math.max(swiperMin, swiperMax);
                  var t = typeof s.getTranslate === 'function' ? s.getTranslate() : s.translate;
                  var delta = accumulatedWheelDelta;
                  accumulatedWheelDelta = 0;
                  var newT = t + delta;
                  newT = Math.max(minT, Math.min(maxT, newT));
                  var progress = maxT !== minT ? (newT - maxT) / (minT - maxT) : 0;
                  if (typeof s.setTransition === 'function') s.setTransition(0);
                  s.setTranslate(newT);
                  if (typeof s.setTransition === 'function') s.setTransition(300);
                  updateProgressBar(s, progress);
                });
              }
            },
            { passive: false },
          );
        },
        slideChange: function () {
          updateProgressBar(this);
        },
        progress: function () {
          updateProgressBar(this);
        },
      },
    });

    swiperElement._ctabSwiper = swiper;
    swiperInstances.set(instanceKey, swiper);
  }

  function initSection(section) {
    if (!section) return;

    updateNoHoverSwapAll();

    const tabTriggers = section.querySelectorAll('[data-ctab-trigger]');
    const tabPanels = section.querySelectorAll('[data-ctab-panel]');

    function initAllSwipers() {
      tabPanels.forEach(function (panel) {
        const swiperElement = panel.querySelector('.ctab__swiper');
        if (swiperElement) {
          const sectionId = swiperElement.dataset.sectionId;
          const tabLabel = swiperElement.dataset.tab;
          const instanceKey = sectionId + '-' + tabLabel;
          if (!swiperInstances.has(instanceKey)) {
            initCtabSwiper(swiperElement, sectionId, tabLabel);
          }
        }
      });
    }

    function switchTab(tab) {
      tabTriggers.forEach(function (triggerButton) {
        const isActive = triggerButton.getAttribute('data-tab') === tab;
        triggerButton.classList.toggle('ctab__tab--active', isActive);
        triggerButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      tabPanels.forEach(function (panel) {
        const active = panel.getAttribute('data-tab') === tab;
        panel.classList.toggle('ctab__panel--active', active);
        panel.hidden = !active;
        if (active) {
          const swiperElement = panel.querySelector('.ctab__swiper');
          if (swiperElement) {
            const sectionId = swiperElement.dataset.sectionId;
            const tabLabel = swiperElement.dataset.tab;
            const instanceKey = sectionId + '-' + tabLabel;

            let swiper = swiperInstances.get(instanceKey);
            if (!swiper) {
              initCtabSwiper(swiperElement, sectionId, tabLabel);
              swiper = swiperInstances.get(instanceKey);
            }

            if (swiper) {
              swiper.update();
            }
          }
        }
      });
    }

    tabTriggers.forEach(function (triggerButton) {
      triggerButton.addEventListener('click', function () {
        const tab = triggerButton.getAttribute('data-tab');
        if (tab) switchTab(tab);
      });
    });

    initAllSwipers();

    section.querySelectorAll('.ctab__card-arrow--prev, .ctab__card-arrow--next').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const card = button.closest('.ctab__card');
        if (card) card.classList.toggle('ctab__card--showing-secondary');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ctab-section]').forEach(initSection);
  }

  window.addEventListener('resize', updateNoHoverSwapAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    var section = document.querySelector('[data-ctab-section][data-section-id="' + sectionId + '"]');
    if (section) {
      setTimeout(function () {
        initSection(section);
        updateNoHoverSwapAll();
      }, 100);
    }
  });
})();
